module.exports = __webpack_public_path__ + "img/emoticon-nps-2-off.35f977a2.svg";